import { render, staticRenderFns } from "./DocContent.vue?vue&type=template&id=c5f710c8&scoped=true&"
import script from "./DocContent.vue?vue&type=script&lang=js&"
export * from "./DocContent.vue?vue&type=script&lang=js&"
import style0 from "./DocContent.vue?vue&type=style&index=0&id=c5f710c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f710c8",
  null
  
)

export default component.exports